import { jsxs as p, jsx as o } from "react/jsx-runtime";
import { FieldErrorAndDescription as b, toast as h } from "@systemeio/ui";
import { UploadIcon as V } from "@systemeio/ui/icons";
import { useRef as Z, useState as _, Children as O } from "react";
import { useTranslation as k } from "../../../../i18n.mjs";
import { variantClassName as q, FileDropZoneVariantEnum as z } from "./constants.mjs";
import { twMerge as u } from "tailwind-merge";
import { formatAcceptTypeForInput as B, isAcceptTypeValid as x } from "../../../../utils/file-input-accept-types.mjs";
function $({
  acceptTypes: t,
  children: m,
  dropZoneClassName: y,
  className: w,
  disabled: a,
  error: N,
  variant: I = z.Medium,
  label: E,
  icon: F = /* @__PURE__ */ o(V, {}),
  isPreFetching: l,
  toastText: n,
  labelClassName: j,
  openNativeWindow: A = !0,
  onSelectFile: d,
  onClick: i
}) {
  const { t: s } = k(), c = Z(null), [C, f] = _(!1), [L, g] = _(""), M = (e) => {
    var r;
    e.preventDefault(), !a && (i == null || i(), A && ((r = c.current) == null || r.click()));
  }, R = (e) => {
    if (e.target.files && e.target.files[0]) {
      const r = e.target.files[0];
      t && !x(r.type, t) ? g(s("file_manager.file_upload.file_not_supported")) : (d(r), n && h.success(n));
    }
    e.target.value = "";
  }, v = (e) => {
    e.preventDefault(), f(!0);
  }, S = (e) => {
    e.preventDefault(), f(!1);
  }, U = (e) => {
    e.preventDefault(), e.stopPropagation();
    const { files: r } = e.dataTransfer;
    if (r && r.length) {
      const D = r[0];
      t && !x(D.type, t) ? g(s("file_manager.file_upload.file_not_supported")) : (d(D), n && h.success(n));
    }
    f(!1);
  };
  return /* @__PURE__ */ p("div", { className: u("font-medium", w), children: [
    /* @__PURE__ */ o(
      "input",
      {
        ref: c,
        type: "file",
        className: "invisible absolute h-1 w-0",
        onChange: R,
        disabled: l || a,
        accept: t && B(t)
      }
    ),
    /* @__PURE__ */ p(
      "button",
      {
        type: "button",
        className: u(
          "bg-background-primary ring-brand-primary flex min-h-[60px] w-full flex-row flex-wrap gap-3 rounded-lg border border-dashed outline-hidden ring-offset-1 focus-visible:ring-2",
          C ? "border-brand-primary" : "border-text-secondary",
          q[I],
          l && "animate-pulse",
          a || l ? "pointer-events-none" : "hover:border-brand-primary cursor-pointer",
          y
        ),
        onDragStart: v,
        onDragLeave: S,
        onDrop: U,
        onDragOver: v,
        onClick: M,
        children: [
          !!O.count(m) && /* @__PURE__ */ o("div", { className: "flex w-full flex-wrap gap-3", children: m }),
          /* @__PURE__ */ p(
            "div",
            {
              className: u(
                "flex w-full flex-col items-center justify-center gap-1",
                j
              ),
              children: [
                F,
                E ?? s("file_manager.file_upload.drop_files_here")
              ]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ o(b, { error: L, errorClassName: "text-center mt-2" }),
    /* @__PURE__ */ o(b, { error: N, errorClassName: "text-center mt-2" })
  ] });
}
export {
  $ as FileUploaderDropZone
};
